import { render } from "./IncentiveComponent.vue?vue&type=template&id=c8dda142&scoped=true&ts=true"
import script from "./IncentiveComponent.vue?vue&type=script&lang=ts"
export * from "./IncentiveComponent.vue?vue&type=script&lang=ts"

import "./IncentiveComponent.vue?vue&type=style&index=0&id=c8dda142&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c8dda142"]])

export default __exports__